import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface PrivateRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, adminOnly = false }) => {
  const { user, isAuthenticated } = useAuth();
  const location = useLocation();

  console.log('PrivateRoute checking access:', { isAuthenticated, userRole: user?.role, adminOnly });

  if (!isAuthenticated) {
    console.log('User not authenticated, redirecting to login');
    // Redirect to login page with the return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && user?.role !== 'admin') {
    console.log('Admin route accessed by non-admin user, redirecting to home');
    // Redirect to home if user is not an admin
    return <Navigate to="/" replace />;
  }

  console.log('Access granted to route');
  return <>{children}</>;
};

export default PrivateRoute;